@if (headerConfig; as config) {
  <div
    class="bd-header gap-4 pointer-events-none"
    [ngClass]="{
      'bd-header-fixed': !!config.position,
      'bd-header-filled': config.position !== 'float',
    }"
  >
    @if (config.navigation) {
      <div class="bd-header-left bd-toolbar">
        <bd-navigation-toolbar
          class="pointer-events-auto"
          [ngClass]="{
            'bd-toolbar-float': config.position === 'float',
            'bd-toolbar-fixed': config.position !== 'float',
          }"
          [navigationToolbarSettings]="config.navigation"
        />
      </div>
    }
    @if (config.dynamic) {
      <div class="bd-header-center bd-toolbar">
        <bd-dynamic-toolbar
          class="pointer-events-auto"
          [ngClass]="{
            'bd-toolbar-float': config.position === 'float',
            'bd-toolbar-fixed': config.position !== 'float',
          }"
        ></bd-dynamic-toolbar>
      </div>
    }
    @if (config.showSearchbar) {
      <div
        class="bd-header-center bd-toolbar pointer-events-auto"
        [ngClass]="{
          'bd-header-searchbar-left': !!featureFlags.trialExperienceEnabled(),
        }"
      >
        <bd-split-search-container
          class="contents"
          [context]="'header'"
        ></bd-split-search-container>
      </div>
    }
    @if (config.account) {
      <div class="bd-header-right bd-toolbar">
        <bd-account-toolbar
          [ngClass]="{
            'bd-toolbar-float': config.position === 'float',
            'bd-toolbar-fixed': config.position !== 'float',
            'pointer-events-none': trialPopoverStore.isTrialExpired(),
            'pointer-events-auto': !trialPopoverStore.isTrialExpired(),
          }"
          [userAvatar]="userAvatar$ | async"
          [accountMenuItems]="(accountMenuItems$ | async) ?? []"
          [accountToolbarSettings]="config.account"
          [showClippy]="clippyStore.enabled()"
          [moveClippyEyebrows]="clippyStore.enabled()"
        />
      </div>
    }
    @if (trialPopoverStore.popoverOpen()) {
      <ng-container *transloco="let t; scope: 'featureTrialExperience'">
        <button
          type="button"
          class="bd-trial-dismiss-overlay"
          data-id="trial-dismiss-overlay"
          tabindex="-1"
          [attr.aria-label]="
            t('featureTrialExperience.trial.dismissPopoverAriaLabel')
          "
          (click)="trialPopoverStore.setPopoverOpen(false)"
        ></button>
      </ng-container>
    }
  </div>
}
